import { useEffect, useState } from "react";
import { Container, Modal, Table } from "../../../components";
import { Link, useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";
import { UserContext } from "../../../context/UserWrapper";
import { useContext } from "react";
import { dataTable, getEspecies } from "./handlers";
import SkeletonTableDataGrid from "../Skeletons/TableDataGrid";

export default function Especies() {
  const { actions: ua } = useContext(UserContext);
  const nav = useNavigate();
  const [especies, setEspecies] = useState({
    data: null,
    error: null,
    params: null,
    loading: false,
  });

  const headers = [
    { label: "ID", key: "id" },
    { label: "Nombre", key: "nombre" },
    { label: "Estado", key: "estado" },
  ];

  // const [open, setOpen] = useState(false);

  useEffect(() => {
    if (ua.hasRole("admin.app")) {
      getEspecies(especies, setEspecies);
    } else {
      nav("/");
    }
  }, []);

  // useEffect(()=>{
  //   console.log("entre")
  //   console.log(especies)
  // },[especies])

  return (
    <Container linkBack={"/admin"} titulo={"Especies"} size={"sm"}>
      {!especies.data && especies.loading && <SkeletonTableDataGrid />}
      {especies.data && (
        <Table
          search={true}
          data={dataTable(especies.data, setEspecies, especies)}
          loading={especies.loading}
          render={() => {
            return (
              <div className="d-flex justify-content-center">
                <Link
                  className="btn btn-sm btn-primary mt-2 mb-2 mx-2 d-flex align-items-center"
                  to="/crear_especie"
                  disabled={especies.loading}
                >
                  Crear Especie
                </Link>
                <CSVLink
                  className="btn btn-success btn-sm mt-2 mb-2 mx-2 d-flex align-items-center gap-2"
                  headers={headers}
                  filename={"listado-especies.csv"}
                  data={especies.data}
                  separator={";"}
                  disabled={especies.loading}
                >
                  <span>Descargar Especies</span>
                </CSVLink>
              </div>
            );
          }}
        />
      )}
    </Container>
  );
}
